module.exports = __webpack_public_path__ + "app/img/Turtle_Airnest_french.a81f2ce5.jpg";